import * as t from './action_types';
// these are UTC, we could do something else..
const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
const today = new Date().toISOString().slice(0, 10);
const INITIAL_STATE = {
    packages: [],
    filters: {
        author_id: '',
        state: ['initialized', 'processing', 'failed', 'soft_failed'],
        date: [yesterday, today],
    },
    selectedPackageIds: [],
};

const videoService = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.SET_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload.filter,
                },
            };

        case t.SET_PACKAGE:
            const { data } = action.payload;

            const packages = state.packages.map((p) => (p.id === data.id ? data : p));
            return {
                ...state,
                isLoading: false,
                hasError: false,
                packages,
            };

        case t.SET_PACKAGE_LIST:
            return {
                ...state,
                isLoading: false,
                hasError: false,
                packages: action.payload.data,
            };

        case t.SET_PACKAGE_LIST_IS_LOADING:
            return {
                ...state,
                isLoading: true,
            };

        case t.SELECT_PACKAGE: {
            const { packageId } = action.payload;

            // to implement multi-select, see users
            return {
                ...state,
                selectedPackageIds: [Number(packageId)],
            };
        }

        case t.UNSELECT_ALL_PACKAGES: {
            return {
                ...state,
                selectedPackageIds: [],
            };
        }

        default:
            return state;
    }
};

export default videoService;
